module.exports = __webpack_public_path__ + "static/media/countdownP.8305321b.jpg";